import React from "react";
import GCDescription from "../GCDescription/GCDescription";
import JoinChicButton from "../JoinChicButton/JoinChicButton";
import "./MainPageHero.css";

function MainPageHero({ backgroundImage }) {
  return (
    <div
      className="main-page-hero-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="main-page-description-wrapper">
        <GCDescription />
      </div>
      <div className="main-page-join-button-wrapper">
        <JoinChicButton />
      </div>
    </div>
  );
}

export default MainPageHero;
